//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ROLES_LIST } from '@/js/constants';
import faq from "@/apps/data-platform/modules/help_center/FAQPage.vue";
import videos from "@/apps/data-platform/modules/help_center/VideosPage.vue";
import sugerences from "@/apps/data-platform/modules/help_center/SugerenciasPage.vue";
import news from "@/apps/data-platform/modules/help_center/NewsPage.vue";
import list_elements from "@/apps/data-platform/modules/help_center/components/list_elements.vue";
export default {
  components: {
    faq: faq,
    videos: videos,
    sugerences: sugerences,
    news: news,
    list_elements: list_elements
  },
  data: function data() {
    return {
      tab: null
    };
  },
  computed: {
    items: function items() {
      return [this.traductor('help_center.news'), this.traductor('help_center.read'), this.traductor('help_center.videos'), this.traductor('help_center.sugerences')];
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    openDialog: function openDialog(t) {
      this.tab = t;
      this.$refs['dialog'].onOpen();
    },
    openFAQ: function openFAQ() {
      //this.$router.push({name: "faq_page"})
      this.$refs['faq'].onOpen();
    },
    openVideos: function openVideos() {
      //this.$router.push({name: "videos_page"})
      this.$refs['videos'].onOpen();
    },
    openSugerencias: function openSugerencias() {
      //this.$router.push({name: "sugerencias_page"})
      this.$refs['sugerences'].onOpen();
    },
    openAdmin: function openAdmin() {
      this.$router.push({
        name: "admin_page"
      });
    },
    onIsAdminUser: function onIsAdminUser() {
      if (window.userInfo.domain != 'intercorp.com.pe') return false;
      var actualRoles = window.userInfo.userRoles;
      console.log("roles:", actualRoles);
      var permission = [ROLES_LIST.ADMIN, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.COMMUNITY_MANAGER];
      var filter = actualRoles.filter(function (actual) {
        return permission.includes(actual) != false;
      });
      console.log(filter);
      if (filter.length > 0) {
        return true;
      }
      return false;
    }
  }
};